<template>
  <v-dialog 
    v-model="dialog" 
    scrollable
    persistent 
    max-width="800px">
    <v-fab-transition 
      v-if="item['.key']" 
      slot="activator">
      <v-btn 
        slot="activator" 
        color="secondary"
        fab
        dark
        small
        absolute
        bottom
        right>
        <v-icon dark>edit</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-fab-transition 
      v-else 
      slot="activator">
      <v-btn
        slot="activator" 
        color="secondary"
        fab
        dark
        absolute
        bottom            
        right>
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-card>
      <v-form 
        ref="form" 
        v-model="valid"                
        lazy-validation>
        <v-toolbar 
          color="primary" 
          dark>
          <v-toolbar-title>
            <span class="headline">{{ item.name ? item.name : 'Add course' }}</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  v-if="!item['.key']"
                  v-model="item.code"
                  :rules="codeRules"
                  :counter="4"
                  label="Code"                          
                  required
                />
                <span 
                  v-if="item['.key']" 
                  class="red--text">Course code can not be changed.</span>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="item.name"
                  :rules="nameRules"
                  :counter="100"
                  label="Name"                          
                  required
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-dialog 
            v-model="confirm" 
            persistent 
            max-width="290">
            <v-btn 
              v-if="item['.key']"
              slot="activator"
              color="red darken-1" 
              flat>Archive</v-btn>
            <v-card>
              <v-card-title class="headline">Archive {{ item.code }}</v-card-title>
              <v-card-text>Recreating the course code will restore the archive.</v-card-text>
              <v-card-actions>
                <v-spacer/>
                <v-btn 
                  color="primary" 
                  flat 
                  @click.native="confirm = false">Close</v-btn>
                <v-btn 
                  color="red darken-1" 
                  flat 
                  @click.native="remove(item)">Archive</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer/>
          <v-btn 
            color="primary" 
            flat 
            @click.native="close">Close</v-btn>
          <v-btn 
            v-if="item['.key']"
            color="primary" 
            flat 
            @click.native="update(item)">Update</v-btn>
          <v-btn 
            v-else
            color="primary" 
            flat 
            @click.native="save(item)">Save</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "CourseForm",
  props: {
    edititem: {
      type: [Array, Object],
      default: null
    }
  },
  data() {
    return {
      dialog: false,
      confirm: false,
      valid: true,
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length < 100) || "Name must be less than 100 characters"
      ],
      codeRules: [
        v => !!v || "Code is required",
        v => (v && v.length !== 3) || "Code must be 4 characters",
        v =>
          /^([A-Z]{1}[0-9]{3})+$/.test(v) ||
          'Expecting capitalised letter followed by 3 numbers. (eg. "E300")'
      ],
      item: JSON.parse(JSON.stringify(this.edititem))
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  methods: {
    save(item) {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        this.$store.dispatch("setLoading", true);
        let updateDate = new Date();
        let updateUser = this.user.displayName;
        let createdDate = new Date();
        let createdUser = this.user.displayName;
        this.$store.getters.db
          .collection("courses")
          .doc(item.code)
          .set({ ...item, updateDate, updateUser, createdDate, createdUser })
          .then(function() {
            console.log("Course successfully written!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "Course " + item.code + " added"
            });
            self.$refs.form.reset();
            self.$store.dispatch("setLoading", false);
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            self.$refs.form.reset();
            self.$store.dispatch("setLoading", false);
          });
      }
    },
    update(item) {
      if (this.$refs.form.validate()) {
        let self = this;
        this.dialog = false;
        let updateItem = JSON.parse(JSON.stringify(item));
        delete updateItem[".key"];
        delete updateItem["code"];
        delete updateItem["createdDate"];
        delete updateItem["createdUser"];
        updateItem.updateDate = new Date();
        updateItem.updateUser = this.user.displayName;
        this.$store.dispatch("setLoading", true);
        this.$store.getters.db
          .collection("courses")
          .doc(this.$route.params.course)
          .update(updateItem)
          .then(function() {
            console.log("Document successfully updated!");
            self.$store.dispatch("sendNotification", {
              snackbar: true,
              color: "success",
              timeout: 6000,
              text: "Course " + item.code + " updated"
            });
            self.$store.dispatch("setLoading", false);
          })
          .catch(function(error) {
            console.error("Error writing document: ", error);
            self.$store.dispatch("setLoading", false);
          });
      }
    },
    remove(item) {
      let self = this;
      this.confirm = false;
      this.dialog = false;
      this.$store.dispatch("setLoading", true);
      this.$store.getters.db
        .collection("courses")
        .doc(this.$route.params.course)
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          self.$store.dispatch("sendNotification", {
            snackbar: true,
            color: "error",
            timeout: 6000,
            text: "Course archived"
          });
          self.$store.dispatch("setLoading", false);
          self.$router.push({ path: "/admin" });
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
          self.$store.dispatch("setLoading", false);
        });
    },
    close() {
      this.$store.dispatch("sendNotification", {
        snackbar: true,
        color: "red darken-2",
        text: this.item.name + " not saved"
      });
      this.dialog = false;
    }
  }
};
</script>
